<template>
  <!--listBody-->
  <div class="content">
    <div class="condition">
      <div class="search_wrap">
        <el-form :inline="true" :model="fromData" class="form-inline">
          <el-form-item>
            <el-date-picker
                    v-model="dataTime"
                    type="daterange"
                    range-separator="-"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :picker-options="pickerOptions1"
                    size="small"
            ></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-input v-model="fromData.keyword" placeholder="请输入关键词查找" size="small"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" size="small" @click="searchFn"></el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="table_wrap">
      <el-table :data="tableData" style="width: 100%">
        <!--        <el-table-column prop="date" type="selection"></el-table-column>-->
        <el-table-column prop="date" label="发布人">
          <template slot-scope="scope">{{scope.row.user_name}}</template>
        </el-table-column>
        <el-table-column label="内容">
          <template slot-scope="scope">
            <div class="contentBox">
              <div class="titleList">{{scope.row.biref}}</div>
              <p @click="privaImgFn(scope.$index)"><i class="el-icon-picture-outline"></i>查看动态图片({{scope.row.num}})</p>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="save_time" label="保存时间"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <!-- @click="handleClick(scope.row)" -->
            <el-button type="text" size="small" @click="pushArticle(scope.row.id)">发布</el-button>
            <el-button type="text" size="small" @click="publish('edit',scope.$index)">查看</el-button>
            <el-button type="text" size="small" @click="detelLine(scope.$index)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pag_wrap" v-if="allPage!==0">
        <el-pagination background layout="prev, pager, next" :total="allPage"></el-pagination>
      </div>
    </div>
    <!--<el-dialog-->
    <!--title="动态图片"-->
    <!--:visible.sync="dialogImgVisible"-->
    <!--width="600"-->
    <!--:before-close="handleClose">-->
    <!--<div class="imgbox">-->
    <!--<img :src="privaImgObj[0]" alt="">-->
    <!--</div>-->
    <!--</el-dialog>-->
    <previewImgDialog title="动态图片" :privaImgObj="privaImgObj" :visible.sync="dialogImgVisible"></previewImgDialog>
  </div>
</template>
<script>
  import previewImgDialog from "@/components/dialog/previewImgDialog.vue";
  import {yeartime, yeartime_} from '@/assets/js/common';
  import {pagination} from "@/util/util.js";
  import api from "@/api.js";

  export default {
    name: "draftBoxPannel",
    components: {
      previewImgDialog
    },
    data() {
      return {
        fromData: {
          page: 1,
          start_time: "",
          end_time: "",
          keyword: ""
        },
        dataTime: [],
        page: {
          pageindex: pagination.pageIndex,
          pagesize: pagination.pageSize,
          total: pagination.total
        },
        radio1: "",
        allPage: 0,
        tableData: [],
        dialogImgVisible: false,
        privaImgObj: [],
        pickerOptions1: {
          disabledDate(time) {
            return time.getTime() > Date.now(); //  - 8.64e7 减去就是不包含今天的
          },
        },
      };
    },
    created() {
      this.InitFn()
    },
    methods: {
      // page 	整型 	必填 	- 	- 	页码
      // start_time 	varchar 	非必填 	- 	- 	开始日期(时间戳)
      // end_time 	varchar 	非必填 	- 	- 	结束日期(时间戳)
      // keyword 	varchar 	非必填 	- 	- 	关键词查找
      InitFn() {
        this.fromData.page = this.page.pageindex
        this.axios
            .post(api.companyadmin_draft_box, this.fromData)
            .then(response => {
              if (response.data.code == 0) {
                for (let i in  response.data.list) {
                  let pic_ = response.data.list[i].pic
                  if (response.data.list[i].pic) {
                    let pic_num = pic_.split(',')
                    response.data.list[i].num = pic_num.length
                  } else {
                    response.data.list[i].num = 0
                  }
                  response.data.list[i].save_time = yeartime(response.data.list[i].save_time)
                }
                this.tableData = response.data.list
                this.allPage = response.data.all_page
              } else {
              }
            })
            .catch(response => {
            });
      },
      pickerOptions(time) {
        // time 是一个new Date数据
        // console.log(time)
      },
      searchFn() {
        this.page.pageindex = 1
        if (this.dataTime) {
          if (this.dataTime.length !== 0) {
            this.fromData.start_time = yeartime_(this.dataTime[0])
            this.fromData.end_time = yeartime_(this.dataTime[1])
          } else {
            this.fromData.start_time = ''
            this.fromData.end_time = ''
          }
        } else {
          this.fromData.start_time = ''
          this.fromData.end_time = ''
        }
        this.InitFn()
      },
      pushArticle(id) {
        const loading = this.$loading({
          lock: true,
          text: '发布中',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.4)',
          customClass:'fontColor'
        });
        this.axios
            .post('companyadmin/diary/release', {diary_id: id})
            .then(response => {
              if (response.data.code == 0) {
                this.$message({
                  message: '发布成功',
                });
                this.InitFn();
                this.$emit('refreshFn')
                loading.close();
              } else {
              }
            })
            .catch(response => {
            });
      },
      publish(option, index) {
        let self_ = this
        if (option === 'edit') {
          // dynamic_type: 0, // 	整型 	必填 	- 	- 	动态类型(0文章、1图文)
          let dynamic_type = 1
          if (Number(self_.tableData[index].dynamic_type) === 1) {
            dynamic_type = 2
          }
          if(sessionStorage.getItem("menu1")){
            this.$router.push({name: "momentsEdit", params: {id: self_.tableData[index].id, dynamic_type: dynamic_type,pageType:option,programaType:2}});
          }else{
            this.$router.push({path: "momentsEdit", query: {id: self_.tableData[index].id, dynamic_type: dynamic_type,pageType:option,programaType:2}});
          }
 
        } else {
          this.$router.push({name: "momentsEdit",pageType:option,programaType:2});
        }
      },
      privaImgFn(index) {
        if (this.tableData[index].num === 0) {
          this.$message({
            message: '没有可查看的图片',
            type: 'warning'
          });
          return
        }
        this.privaImgObj = this.tableData[index].pic.split(',')
        this.dialogImgVisible = true
      },
      detelLine(index) {
        let self_ = this
        this.$confirm('是否删除该动态?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          showClose: false,
          closeOnClickModal: false
        }).then(() => {
          self_.axios
              .post('companyadmin/diary/delete', {diary_id: self_.tableData[index].id})
              .then(response => {
                if (response.data.code == 0) {
                  self_.InitFn()
                  self_.activeList.splice(index, 1)
                  self_.$message({
                    message: '删除成功!'
                  });
                } else {
                }
              })
              .catch(response => {
              });
        }).catch(() => {
        });
      },
    }
  };
</script>
